import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {AuthService} from '../../../shared/service/auth.service';
import {CategoryService} from '../../../shared/service/category.service';
import {ConfigurationService} from '../../../shared/service/configuration.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-tiny-mice',
    templateUrl: './tiny-mice.component.html',
    styleUrls: ['./tiny-mice.component.scss']
})
export class TinyMiceComponent implements OnInit, OnChanges, OnDestroy {


    public valueeee: any;
    ////tinymicee //
    @Output() emitEditorValue = new EventEmitter<any>();
    @Input() editorPatchValue: any;
    @Input() readonly: boolean;
    @Input() height: number;
    @Input() width: number;
    @Input() id: any;
    @Input() showInputBtn: boolean;
    @Input() showDropBtn: boolean;
    @Input() hideBackcolr: boolean;
    @Input() hideMatEditor = false;
    @Input() imageToolHide: boolean;
    @Input() inlineEditor?: boolean = false;

    // public editorSet: any;
    public editorConf: any;
    public editorParent: any;
    public parentCb: any;
    public imgUrl: any;
    public getRandom: any;
    public editorElementId = '';
    private editorReady = false;

    //// tiny mice closed

    constructor(public auth: AuthService, public sanitizer: DomSanitizer, public category: CategoryService,
                public config: ConfigurationService, public cdr: ChangeDetectorRef, private ngZone: NgZone) {
        ///// hiding bacground coldr toolbar in the editor
        this.hideBackcolr = this.hideBackcolr ? this.hideBackcolr : false;
        this.imageToolHide = this.imageToolHide ? this.imageToolHide : false;
        this.imgUrl = this.config?.getimgUrl();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.readonly) {
            this.editorParent?.mode?.set('readonly');
        } else {
            this.editorParent?.mode?.set('design');
        }

        if (changes['editorPatchValue'] && this.editorParent) {
            const nextValue = this.editorPatchValue || '';
            if (changes['editorPatchValue'].firstChange || changes['editorPatchValue'].previousValue !== nextValue) {
                this.editorParent.setContent(nextValue);
                this.cdr.detectChanges();
            }
        }
    }

    private buildToolbar(): string {
        if (this.hideBackcolr) {
            const segments = [
                'undo redo',
                'formatselect',
                'imagetools',
                'alignleft aligncenter alignright alignjustify',
            ];
            if (!this.hideMatEditor) {
                segments.push('tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry');
            }
            if (this.showInputBtn) {
                segments.push('customInsertButton');
            }
            if (this.showDropBtn) {
                segments.push('mybutton');
            }
            segments.push('image', 'bullist numlist outdent indent', 'removeformat', 'help');
            return segments.join(' | ');
        }

        const segments: string[] = [
            'undo redo',
            'formatselect',
            'bold italic forecolor backcolor',
        ];
        if (!this.imageToolHide) {
            segments.push('imagetools');
        }
        segments.push('alignleft aligncenter alignright alignjustify');
        if (!this.hideMatEditor) {
            segments.push('tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry');
        }
        if (this.showInputBtn) {
            segments.push('customInsertButton');
        }
        if (this.showDropBtn) {
            segments.push('mybutton');
        }
        if (!this.imageToolHide) {
            segments.push('image');
        }
        segments.push('bullist numlist outdent indent', 'removeformat', 'help');
        return segments.join(' | ');
    }

    private buildPlugins(): string {
        const base = 'advlist autolink lists link charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste help wordcount';
        if (this.imageToolHide) {
            return base;
        }
        return `${base} image imagetools`;
    }

    private removeStaleEditor(editorId?: string): void {
        const tinymce = (window as any).tinymce;
        if (!tinymce || !editorId) {
            return;
        }
        const existing = tinymce.get(editorId);
        if (existing) {
            existing.remove();
        }
    }

    private finishEditorInit(editor: any): void {
        if (this.editorReady) {
            return;
        }
        this.editorReady = true;
        this.editorParent = editor;
        this.ngZone.run(() => {
            if (this.readonly) {
                editor.mode.set('readonly');
            }
            editor.setContent(this.editorPatchValue || '');
            const content = editor.getContent();
            this.emitEditorValue.emit({ editor, content });
            this.cdr.detectChanges();
        });
    }

    onEditorInit(event: any): void {
        const editor = event?.editor || this.editorParent;
        if (editor) {
            this.finishEditorInit(editor);
        }
    }

    ngOnInit(): void {
        const toolbar = this.buildToolbar();
        let input: any;
        this.imgUrl = this.config?.getimgUrl();
        this.getRandom = Math.random().toFixed(6).replace('.', '');
        const baseId = (this.id || 'tiny-mice').toString().replace(/[^a-zA-Z0-9_-]/g, '');
        this.editorElementId = `${baseId}-${this.getRandom}`;
        this.removeStaleEditor(this.id);
        this.removeStaleEditor(this.editorElementId);
        this.editorReady = false;

        const conf: any = {
            height: this.height ? this.height : 110,
            width: this.width ? this.width : '100%',
            menubar: false,
            inline: this.inlineEditor,
            hidden_input: false,
            body_class: 'inlineEditor',
            branding: false,
            file_picker_types: 'image',
            paste_data_images: true,
            paste_as_text: true,
            image_advtab: false,
            image_uploadtab: true,
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            draggable_modal: true,
            elementpath: false,
            toolbar_mode: 'sliding',
            toolbar_sticky: false,
            base_url: 'tinymce',
            suffix: '.min',
            file_picker_callback: (cb, value, meta) => {
                this.parentCb = cb;
                input = document.getElementById('imageUpload' + this.getRandom);
                input?.click();
            },
            plugins: this.buildPlugins(),
            init_instance_callback: (editor: any) => {
                this.finishEditorInit(editor);
            },
            setup: editor => {
                this.editorParent = editor;
                if (editor.initialized) {
                    this.finishEditorInit(editor);
                }
                editor.on('change', () => {
                    const content = editor.getContent();
                    if (this.readonly) {
                        editor.mode.set('readonly');
                    }
                    this.emitEditorValue.emit({ editor, content });
                });
                editor.on('keyup', () => {
                    const content = editor.getContent();
                    this.emitEditorValue.emit({ editor, content });
                });
                if (this.showDropBtn) {
                    editor.ui.registry.addButton('mybutton', {
                        type: 'menubutton',
                        text: 'Add Drop Down',
                        onAction: function (_) {
                            editor.insertContent('<input class="dropDownValue" readonly placeholder="DropDown box">');
                        }
                    });
                }
                if (this.showInputBtn) {
                    editor.ui.registry.addButton('customInsertButton', {
                        text: 'Add Input',
                        onAction: function (_) {
                            editor.insertContent('<input class="inputValue" readonly placeholder="input box">');
                        }
                    });
                }
            },
            toolbar
        };

        if (!this.hideMatEditor) {
            conf.external_plugins = {
                tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
            };
        }

        this.editorConf = conf;
    }

    ngOnDestroy(): void {
        this.editorReady = false;
        if (this.editorParent) {
            try {
                this.editorParent.remove();
            } catch (_) {
                // editor may already be destroyed by tinymce-angular
            }
            this.editorParent = null;
        }
        this.removeStaleEditor(this.editorElementId);
        this.removeStaleEditor(this.id);
    }

    // manuallTrigger1(event){
    //   this.editorSet = event.editor;
    // }
    // manuallTrigger(){
    //   console.log(this.editorSet , 'set');
    //
    // }


    encodeImageFileAsURL(event: any) {
        console.log(event, 'lkhljl');
        for (let i = 0; i < event.target.files.length; i++) {
            const getUrlEdu = '';
            const imgDetails = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const url = event.target.result;
                const getUrl = url.split(',');
                const pic = imgDetails.type.split('/');
                if (pic[1] == 'jpeg' || pic[1] == 'png' || pic[1] == 'jpg') {
                    this.onUploadKYCFinished(getUrl, imgDetails);
                } else {
                    console.error('JPEG ,PNG & JPG are the required type');
                }
            };
            reader.readAsDataURL(event.target.files[i]);
        }
    }

    onUploadKYCFinished(getUrlEdu, data) {
        const imgData = [{
            image: getUrlEdu[1],
            size: data.size,
            type: data.type,
            name: data.name
        }];
        this.getUrlImage(imgData);
    }

    getUrlImage(imgData) {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            image_path: imgData,
            uploadtype: 'profile'
        };
        this.category.getImgUrl(data).subscribe(
            (successData) => {
                this.getUrlImageSuccess(successData);
            },
            (error) => {
                console.error(error, 'uploadFailed_TinyMice');
            }
        );
    }

    public getUrlImageSuccess(successData) {
        if (successData.IsSuccess) {
            console.log(this.config?.getimgUrl() + '/' + successData.ResponseObject.imagepath[0].original_image_url, 'path');
            this.parentCb(this.config?.getimgUrl() + '/' + successData.ResponseObject.imagepath[0].original_image_url, {title: 'RISTA'});
            let input: any = document.getElementById('imageUpload' + this.getRandom) as HTMLElement;
            input.value = '';

        }
    }
}
